import { Box, Dialog, Typography, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    padding: '1rem',
    minWidth: '320px',
  },
});

export const DialogHeader = styled(Typography)({
  fontSize: '1.125rem',
  fontWeight: 600,
  color: '#111827',
  textAlign: 'center',
  marginBottom: '0.5rem',
  fontFamily: 'Neue Frutiger World',
});

export const DialogMessage = styled(Typography)({
  fontSize: '0.875rem',
  color: '#6B7280',
  textAlign: 'center',
  marginBottom: '1.5rem',
  fontFamily: 'Neue Frutiger World',
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  width: '100%',
});
